import { Outlet } from "react-router";

export const Empty = () => (
	<div className="flex flex-col items-center justify-center min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
		<main className="max-w-xl w-full p-6 text-center">
			<Outlet />
		</main>
	</div>
);
